import { render, staticRenderFns } from "./editPaxelMarketPartners.vue?vue&type=template&id=696a0f8f&"
import script from "./editPaxelMarketPartners.vue?vue&type=script&lang=js&"
export * from "./editPaxelMarketPartners.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports